export const RAILWAY_FEATURE_FLAGS = {
  presubmissionEditability: 'use_presubmission_editability_enabled',
  specialPayment20: 'use_20_sp',
  borrowerFormV2: 'use_borrower_form_v2',
  newEquipmentOrderFundingRequest: 'use_new_equipment_order_funding_request',
  newStampedConstructionPlans: 'use_new_stamped_construction_plans',
  newUploadEquipmentPhotos: 'use_new_upload_equipment_photos',
  newExecutedInstallationAgreement: 'use_new_executed_installation_agreement',
  ledger: 'use_ledger',
  ledgerUi: 'use_ledger_ui',
  legacyUiLelDetails: 'use_legacy_ui_lel_details',
  lelTestUsersOnly: 'lel_test_users_only',
  newProjectsTable: 'use_new_projects_table',
  alertsInProjects: 'use_alerts_in_projects',
  milestoneCostCalculator: 'use_milestone_cost_calculator',
  showSolarEconCalculator: 'showSolarEconCalculator',
} as const;

export type RailwayFeatureFlag =
  (typeof RAILWAY_FEATURE_FLAGS)[keyof typeof RAILWAY_FEATURE_FLAGS];
